import styled from "styled-components";

export const Foot = styled.footer`
	margin-top: 200px;
	padding: 0 150px 0 150px;
	display: flex;
	flex-wrap: wrap;
	align-items: stretch;
	justify-content: space-between;

	box-shadow: 0px 0px 9px -1px rgba(0, 0, 0, 0.25);
	-webkit-box-shadow: 0px 0px 9px -1px rgba(0, 0, 0, 0.25);
	-moz-box-shadow: 0px 0px 9px -1px rgba(0, 0, 0, 0.25);

	@media screen and (max-width: 780px) {
		justify-content: center;
		column-gap: 24px;
		row-gap: 15px;
		padding: 0 30px 30px 30px;
	}

	.media-wrapper {
		align-self: center;

		span {
			font-size: 0.8rem;
			color: var(--lightGrey);
			font-weight: 400;
		}

		@media screen and (max-width: 600px) {
			padding-top: 0;
		}
	}
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: stretch;
	padding: 32px 0;

	h2 {
		font-size: var(--fontMed);
		color: var(--lightGrey);
		font-weight: 500;
	}

	@media screen and (max-width: 600px) {
		padding: 5px 0;
	}
`;

export const Content = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 16px;
	margin-bottom: 20px;
`;
export const AnchorMedia = styled.a`
	text-decoration: none;
	display: block;
	height: 25px;
	color: var(--medGrey);

	:hover {
		${props =>
			props.children
				? `box-shadow: 0 0 0 3px var(--lightGrey);
				background-color: var(--lightGrey);
			border-radius:1000px;
			color:var(--white)`
				: ""};
	}
`;

export const ContentOpen = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: stretch;

	p {
		font-size: var(--fontSmall);
		color: var(--lightGrey);
		padding-top: 18px;
		font-weight: 500;
	}
`;
